/* eslint-disable no-nested-ternary */
import Trans from 'next-translate/Trans'
import React, { useEffect, useState } from 'react'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import { STATUS_WAITING_FOR_OFFER } from 'tennders-stracture/libs/constants'
import GHref from 'tennders-market/common/components/element/GHref'
import DOMPurify from 'dompurify'
import dynamic from 'next/dynamic'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsAltH } from '@fortawesome/free-solid-svg-icons'
import LoadOffer from './LoadOffer'
import TruckOffer from './TruckOffer'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

const FirstOfferMatchingTruck = ({
  transaction,
  offering,
  setoffering
}) => {
  if (transaction?.isMine
    || transaction?.status?.label !== STATUS_WAITING_FOR_OFFER) {
    return null
  }
  return transaction?.status?.label === STATUS_WAITING_FOR_OFFER
    ? (
      <GHref
        onClick={setoffering}
        className="btn-border standard-btn mr-8"
      >
        {offering ? <Trans i18nKey="offer:cancel" />
          : (
            <Trans i18nKey="offer:firstOfferToTruck" />
          )}
      </GHref>
    )
    : (
      transaction.bookedBy ? null
        : (
          <GHref className="mr-8 btn-border standard-btn tennders-truck-first-offer-btn disabled">
            <Trans i18nKey={`variables:${transaction?.status?.label}`} />
          </GHref>
        )

    )
}

const FirstOffer = ({
  transaction,
  setoffering,
  offering
}) => (
  !transaction?.isUnderNegotiation && !transaction?.bookedBy
    ? (
      <GHref
        onClick={() => setoffering(!offering)}
        className="btn-border standard-btn mr-8"
      >
        {offering ? <Trans i18nKey="offer:cancel" />
          : (
            <Trans i18nKey="offer:offerToLoad" />
          )}
      </GHref>
    )
    : (
      <GHref className="mr-8 btn-border standard-btn tennders-truck-first-offer-btn disabled">
        <Trans i18nKey={`variables:${transaction?.status?.label}`} />
      </GHref>
    )
)

const SingleMatchLoad = ({ toMatch, onRefresh }) => {
  const { transaction } = useTransaction()

  // const [offeringToTruck, setofferingToTruck] = useState(false);
  // const [offeringToLoad, setofferingToLoad] = useState(false);
  const [assigning, setassigning] = useState(false)
  const {
    offeringToLoad, offeringToTruck,
    setOfferingToLoad, setOfferingToTruck,
    setOfferingToMatch, offeringToMatch
  } = useOffer()
  const item = toMatch?.matchedLoad

  useEffect(() => {
    if (offeringToLoad) {
      setOfferingToTruck(false)
    }
  }, [offeringToLoad])

  useEffect(() => {
    if (offeringToTruck) {
      setOfferingToLoad(false)
    }
  }, [offeringToTruck])

  const offerToTruck = ({ transaction, toMatch }) => {
    if (transaction?.id === offeringToTruck?.id
      && toMatch?.id === offeringToMatch?.id) {
      setOfferingToTruck(false)
      setOfferingToMatch(false)
    } else {
      setOfferingToTruck(transaction)
      setOfferingToMatch(toMatch)
    }
  }

  const offerToLoad = ({ transaction }) => {
    if (transaction?.id === offeringToLoad?.id) {
      setOfferingToLoad(false)
    } else {
      setOfferingToLoad(transaction)
    }
  }

  return (
    <tr>
      <td>
        <table className={`tennders-table-zebra border-b ${toMatch?.isMarketPlaced ? 'bg-color-s-op15' : null}`}>
          <tbody>
            <tr>
              <td>
                <h4 className="bold mb-0">
                  {item?.company?.name}
                </h4>
                <div className="text-12 conform-email">
                  <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>{item?.company?.email}</EllipsisToolTip>
                </div>
              </td>
              <td className="text-right">
                {assigning && (
                  <GHref
                    onClick={() => setassigning(false)}
                    className="btn-border standard-btn mr-8"
                  >
                    <Trans i18nKey="offer:cancel" />
                  </GHref>
                )}
                <>
                  <FirstOfferMatchingTruck
                    offering={offeringToTruck?.id === transaction?.id
                    && offeringToMatch?.id === toMatch?.id}
                    setoffering={() => offerToTruck({ transaction, toMatch })}
                    transaction={transaction}
                    toMatch={toMatch}
                  />

                  {!toMatch.isMine ? (
                    <FirstOffer
                      transaction={toMatch}
                      setoffering={() => offerToLoad({ transaction: toMatch })}
                      offering={offeringToLoad?.id === toMatch?.id}
                    />
                  ) : null}
                </>

              </td>
            </tr>

            <tr>
              <td colSpan="2">
                <table className="tennders-table-zebra text-center text-12">
                  <tbody>
                    <tr>
                      <td>
                        <strong>{toMatch?.pickupRoute?.label}</strong>
                        {' '}
                        <br />
                        <div className="text-mid-hray">
                          {toMatch?.pickupRoute?.date?.f}
                        </div>
                      </td>
                      <td>
                        <FontAwesomeIcon icon={faArrowsAltH} fontSize={24} className="text-mid-gray" aria-hidden="true" />
                      </td>
                      <td>
                        <strong>{toMatch?.deliveryRoute?.label}</strong>
                        {' '}
                        <br />
                        <div className="text-mid-hray">
                          {toMatch?.deliveryRoute?.date?.f}
                        </div>

                      </td>
                      <td className="text-left border-l pl-24">
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.detailedInfo) }} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            {offeringToTruck?.id === transaction?.id
            && offeringToMatch?.id === toMatch?.id
              ? (
                <TruckOffer
                  fillMap
                  onRefresh={onRefresh}
                  loadTransaction={toMatch}
                  truckTransaction={transaction}
                />
              ) : null}

            {offeringToLoad?.id === toMatch.id
              ? (
                <LoadOffer
                  onRefresh={onRefresh}
                  loadTransaction={toMatch}
                  truckTransaction={transaction}
                />
              ) : null}
          </tbody>
        </table>
      </td>
    </tr>
  )
}

export default SingleMatchLoad
